module.exports = __webpack_public_path__ + "img/youye0.gif";